export const isValidStringOrNumber = (e: any) =>
    typeof e === "string" || typeof e === "number";
